module.exports = __webpack_public_path__ + "img/truck.cc94052d.svg";